import { render, staticRenderFns } from "./SMSServiceLogs.vue?vue&type=template&id=47bd1f0a"
import script from "./SMSServiceLogs.vue?vue&type=script&lang=js"
export * from "./SMSServiceLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports